module.exports = __webpack_public_path__ + "assets/img/a0c1092f5f02be65cf3c44de2196aca1.svg";